import React, { useState } from "react";
import { LegalDialog } from "./Legal";
import { LOGO_URL } from "../lib/branding";

export default function Footer() {
  const [open, setOpen] = useState(null); // 'impressum' | 'datenschutz' | null

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-12 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <a href="#home" className="inline-flex items-center gap-4">
              <span className="w-28 h-28 md:w-32 md:h-32 shrink-0 inline-block logo-blend">
                <img
                  src={LOGO_URL}
                  alt="Autohaus Barwinski Logo"
                  className="w-full h-full object-cover"
                />
              </span>
              <div className="leading-tight">
                <div className="font-display text-base md:text-lg uppercase tracking-tight">
                  Autohaus Barwinski
                </div>
                <div className="text-[10px] text-zinc-500 tracking-[0.2em] uppercase mt-1">
                  by Spitzer und Demirci GmbH
                </div>
              </div>
            </a>
            <p className="mt-5 text-sm text-zinc-400 max-w-md leading-relaxed">
              Meisterwerkstatt in Neuss. Seit 2024 geführt von den Kfz-Meistern
              Vitali Spitzer und Taner Demirci. Ehrlich. Zuverlässig.
            </p>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-4">
              Navigation
            </div>
            <ul className="space-y-2 text-sm">
              {[
                { l: "Start", h: "#home" },
                { l: "Leistungen", h: "#leistungen" },
                { l: "Über uns", h: "#ueber-uns" },
                { l: "So läuft's", h: "#ablauf" },
                { l: "FAQ", h: "#faq" },
                { l: "Termin", h: "#termin" },
                { l: "Kontakt", h: "#kontakt" },
              ].map((i) => (
                <li key={i.h}>
                  <a
                    href={i.h}
                    className="text-zinc-300 hover:gold-text transition-colors"
                    data-testid={`footer-link-${i.h.replace("#", "")}`}
                  >
                    {i.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-4">
              Kontakt
            </div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li>Normannenstraße 22</li>
              <li>41462 Neuss</li>
              <li className="pt-2">
                <a
                  href="tel:02131544154"
                  className="hover:gold-text transition-colors"
                >
                  Tel: 02131 544154
                </a>
              </li>
              <li>
                <a
                  href="mailto:kfz-spitzer@gmx.de"
                  className="hover:gold-text transition-colors"
                >
                  kfz-spitzer@gmx.de
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-[11px] tracking-[0.25em] uppercase text-zinc-500">
            © {new Date().getFullYear()} Autohaus Barwinski · Spitzer und Demirci GmbH
          </div>
          <div className="flex items-center gap-5 text-[11px] tracking-[0.25em] uppercase">
            <button
              data-testid="footer-impressum"
              onClick={() => setOpen("impressum")}
              className="text-zinc-400 hover:gold-text transition-colors"
            >
              Impressum
            </button>
            <button
              data-testid="footer-datenschutz"
              onClick={() => setOpen("datenschutz")}
              className="text-zinc-400 hover:gold-text transition-colors"
            >
              Datenschutz
            </button>
          </div>
        </div>
      </div>
      <div className="h-1 gold-bg" />

      <LegalDialog
        open={open !== null}
        onOpenChange={(o) => !o && setOpen(null)}
        kind={open || "impressum"}
      />
    </footer>
  );
}
